/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetListingsParams,
  ListingResponseDto,
  ListingsListResponseDto,
  PortalListingContactBodyDto,
  PortalListingRevealPhoneBodyDto,
  PortalListingRevealPhoneResponseDto
} from './model';

import { mutator } from '../mutator';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getTopListings = (

 options?: SecondParameter<typeof mutator>,signal?: AbortSignal
) => {


      return mutator<ListingResponseDto[]>(
      {url: `/api/v1/listings/top`, method: 'GET', signal
    },
      options);
    }



export const getGetTopListingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTopListings>>, TError,void, TContext>, request?: SecondParameter<typeof mutator>}
): UseMutationOptions<Awaited<ReturnType<typeof getTopListings>>, TError,void, TContext> => {

const mutationKey = ['getTopListings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTopListings>>, void> = () => {


          return  getTopListings(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTopListingsMutationResult = NonNullable<Awaited<ReturnType<typeof getTopListings>>>

    export type GetTopListingsMutationError = unknown

    export const useGetTopListings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTopListings>>, TError,void, TContext>, request?: SecondParameter<typeof mutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTopListings>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetTopListingsMutationOptions(options), queryClient);
    }
    export const getSimilarListings = (
    id: string,
 options?: SecondParameter<typeof mutator>,signal?: AbortSignal
) => {


      return mutator<ListingsListResponseDto>(
      {url: `/api/v1/listings/${id}/similar`, method: 'GET', signal
    },
      options);
    }



export const getGetSimilarListingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSimilarListings>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof mutator>}
): UseMutationOptions<Awaited<ReturnType<typeof getSimilarListings>>, TError,{id: string}, TContext> => {

const mutationKey = ['getSimilarListings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSimilarListings>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  getSimilarListings(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetSimilarListingsMutationResult = NonNullable<Awaited<ReturnType<typeof getSimilarListings>>>

    export type GetSimilarListingsMutationError = unknown

    export const useGetSimilarListings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSimilarListings>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof mutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getSimilarListings>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getGetSimilarListingsMutationOptions(options), queryClient);
    }
    export const sendListingContactEmail = (
    portalListingContactBodyDto: PortalListingContactBodyDto,
 options?: SecondParameter<typeof mutator>,signal?: AbortSignal
) => {


      return mutator<void>(
      {url: `/api/v1/listings/contact`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: portalListingContactBodyDto, signal
    },
      options);
    }




export const getSendListingContactEmailQueryKey = (portalListingContactBodyDto?: PortalListingContactBodyDto,) => {
    return [
    'POST', `/api/v1/listings/contact`, portalListingContactBodyDto
    ] as const;
    }


export const getSendListingContactEmailQueryOptions = <TData = Awaited<ReturnType<typeof sendListingContactEmail>>, TError = unknown>(portalListingContactBodyDto: PortalListingContactBodyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sendListingContactEmail>>, TError, TData>>, request?: SecondParameter<typeof mutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSendListingContactEmailQueryKey(portalListingContactBodyDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sendListingContactEmail>>> = ({ signal }) => sendListingContactEmail(portalListingContactBodyDto, requestOptions, signal);





   return  { queryKey, queryFn,   staleTime: 30000, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sendListingContactEmail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SendListingContactEmailQueryResult = NonNullable<Awaited<ReturnType<typeof sendListingContactEmail>>>
export type SendListingContactEmailQueryError = unknown


export function useSendListingContactEmail<TData = Awaited<ReturnType<typeof sendListingContactEmail>>, TError = unknown>(
 portalListingContactBodyDto: PortalListingContactBodyDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sendListingContactEmail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sendListingContactEmail>>,
          TError,
          Awaited<ReturnType<typeof sendListingContactEmail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof mutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSendListingContactEmail<TData = Awaited<ReturnType<typeof sendListingContactEmail>>, TError = unknown>(
 portalListingContactBodyDto: PortalListingContactBodyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sendListingContactEmail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sendListingContactEmail>>,
          TError,
          Awaited<ReturnType<typeof sendListingContactEmail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof mutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSendListingContactEmail<TData = Awaited<ReturnType<typeof sendListingContactEmail>>, TError = unknown>(
 portalListingContactBodyDto: PortalListingContactBodyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sendListingContactEmail>>, TError, TData>>, request?: SecondParameter<typeof mutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSendListingContactEmail<TData = Awaited<ReturnType<typeof sendListingContactEmail>>, TError = unknown>(
 portalListingContactBodyDto: PortalListingContactBodyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sendListingContactEmail>>, TError, TData>>, request?: SecondParameter<typeof mutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSendListingContactEmailQueryOptions(portalListingContactBodyDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const revealListingPhone = (
    portalListingRevealPhoneBodyDto: PortalListingRevealPhoneBodyDto,
 options?: SecondParameter<typeof mutator>,signal?: AbortSignal
) => {


      return mutator<PortalListingRevealPhoneResponseDto>(
      {url: `/api/v1/listings/reveal-phone`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: portalListingRevealPhoneBodyDto, signal
    },
      options);
    }




export const getRevealListingPhoneQueryKey = (portalListingRevealPhoneBodyDto?: PortalListingRevealPhoneBodyDto,) => {
    return [
    'POST', `/api/v1/listings/reveal-phone`, portalListingRevealPhoneBodyDto
    ] as const;
    }


export const getRevealListingPhoneQueryOptions = <TData = Awaited<ReturnType<typeof revealListingPhone>>, TError = unknown>(portalListingRevealPhoneBodyDto: PortalListingRevealPhoneBodyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof revealListingPhone>>, TError, TData>>, request?: SecondParameter<typeof mutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRevealListingPhoneQueryKey(portalListingRevealPhoneBodyDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof revealListingPhone>>> = ({ signal }) => revealListingPhone(portalListingRevealPhoneBodyDto, requestOptions, signal);





   return  { queryKey, queryFn,   staleTime: 30000, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof revealListingPhone>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RevealListingPhoneQueryResult = NonNullable<Awaited<ReturnType<typeof revealListingPhone>>>
export type RevealListingPhoneQueryError = unknown


export function useRevealListingPhone<TData = Awaited<ReturnType<typeof revealListingPhone>>, TError = unknown>(
 portalListingRevealPhoneBodyDto: PortalListingRevealPhoneBodyDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof revealListingPhone>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof revealListingPhone>>,
          TError,
          Awaited<ReturnType<typeof revealListingPhone>>
        > , 'initialData'
      >, request?: SecondParameter<typeof mutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRevealListingPhone<TData = Awaited<ReturnType<typeof revealListingPhone>>, TError = unknown>(
 portalListingRevealPhoneBodyDto: PortalListingRevealPhoneBodyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof revealListingPhone>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof revealListingPhone>>,
          TError,
          Awaited<ReturnType<typeof revealListingPhone>>
        > , 'initialData'
      >, request?: SecondParameter<typeof mutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRevealListingPhone<TData = Awaited<ReturnType<typeof revealListingPhone>>, TError = unknown>(
 portalListingRevealPhoneBodyDto: PortalListingRevealPhoneBodyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof revealListingPhone>>, TError, TData>>, request?: SecondParameter<typeof mutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRevealListingPhone<TData = Awaited<ReturnType<typeof revealListingPhone>>, TError = unknown>(
 portalListingRevealPhoneBodyDto: PortalListingRevealPhoneBodyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof revealListingPhone>>, TError, TData>>, request?: SecondParameter<typeof mutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRevealListingPhoneQueryOptions(portalListingRevealPhoneBodyDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * @summary Zoznam inzeratov (SHIM - doplnene lokalne, chyba v contracte)
 */
export const getListings = (
    params?: GetListingsParams,
 options?: SecondParameter<typeof mutator>,signal?: AbortSignal
) => {


      return mutator<ListingsListResponseDto>(
      {url: `/api/v1/listings`, method: 'GET',
        params, signal
    },
      options);
    }



export const getGetListingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getListings>>, TError,{params?: GetListingsParams}, TContext>, request?: SecondParameter<typeof mutator>}
): UseMutationOptions<Awaited<ReturnType<typeof getListings>>, TError,{params?: GetListingsParams}, TContext> => {

const mutationKey = ['getListings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getListings>>, {params?: GetListingsParams}> = (props) => {
          const {params} = props ?? {};

          return  getListings(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetListingsMutationResult = NonNullable<Awaited<ReturnType<typeof getListings>>>

    export type GetListingsMutationError = unknown

    /**
 * @summary Zoznam inzeratov (SHIM - doplnene lokalne, chyba v contracte)
 */
export const useGetListings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getListings>>, TError,{params?: GetListingsParams}, TContext>, request?: SecondParameter<typeof mutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getListings>>,
        TError,
        {params?: GetListingsParams},
        TContext
      > => {
      return useMutation(getGetListingsMutationOptions(options), queryClient);
    }
    /**
 * @summary Detail inzeratu (SHIM - doplnene lokalne, chyba v contracte)
 */
export const getListing = (
    id: string,
 options?: SecondParameter<typeof mutator>,signal?: AbortSignal
) => {


      return mutator<ListingResponseDto>(
      {url: `/api/v1/listings/${id}`, method: 'GET', signal
    },
      options);
    }



export const getGetListingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getListing>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof mutator>}
): UseMutationOptions<Awaited<ReturnType<typeof getListing>>, TError,{id: string}, TContext> => {

const mutationKey = ['getListing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getListing>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  getListing(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetListingMutationResult = NonNullable<Awaited<ReturnType<typeof getListing>>>

    export type GetListingMutationError = unknown

    /**
 * @summary Detail inzeratu (SHIM - doplnene lokalne, chyba v contracte)
 */
export const useGetListing = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getListing>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof mutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getListing>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getGetListingMutationOptions(options), queryClient);
    }
